export default "__VITE_ASSET__CcYjJ0mI__"